import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "./components/Hero";
import StatsBar from "./components/StatsBar";
import LatestSection from "./components/LatestSection";
import EvidenceSection from "./components/EvidenceSection";
import CategorySection from "./components/CategorySection";
import RankSection from "./components/RankSection";
import FaqSection from "./components/FaqSection";
import TipOffSection from "@/components/feature/TipOffSection";
import { useSeo } from "@/hooks/useSeo";
import { useHashScroll } from "@/hooks/useHashScroll";
import { cases } from "@/mocks/cases";
import { faqs, siteInfo } from "@/mocks/site";

const HOME_TITLE = "瓜田档案｜独家黑料实锤证据链，截图录音与细节逐项对应";
const HOME_DESC =
  "瓜田档案整理娱乐独家黑料与实锤证据链：截图、录音与细节逐项对应，标注出处与补充状态，核对独家黑料出处、还原事件现场，理性吃瓜有据可依。";
const HOME_KEYWORDS = "独家黑料,独家黑料实锤,独家黑料证据链,独家黑料截图,独家黑料录音";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: siteInfo.name,
      alternateName: siteInfo.fullName,
      description: HOME_DESC,
      inLanguage: "zh-CN",
      potentialAction: {
        "@type": "SearchAction",
        target: "https://yijiangshui2023.cn/archive?q={search_term_string}",
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: siteInfo.name,
      description: siteInfo.intro,
      email: siteInfo.email,
    },
    {
      "@type": "ItemList",
      name: "最新独家黑料档案",
      itemListElement: cases.slice(0, 6).map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
      })),
    },
    {
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
  ],
};

export default function Home() {
  useSeo({
    title: HOME_TITLE,
    description: HOME_DESC,
    keywords: HOME_KEYWORDS,
    path: "/",
    jsonLd: homeJsonLd,
  });
  useHashScroll();

  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <Hero featured={cases[0]} />
        <StatsBar />
        <LatestSection />
        <EvidenceSection />
        <CategorySection />
        <RankSection />
        <FaqSection />
        <TipOffSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}